import { Pipe, PipeTransform } from '@angular/core';
import { Vector2, WordRect } from '../model';

@Pipe({
  name: 'rectDisplayStyle',
})
export class RectDisplayStylePipe implements PipeTransform {
  transform(rect: WordRect, offset: Vector2 = [0, 0]): Record<string, string> {
    return {
      left: `${rect.x[0] + offset[0]}px`,
      top: `${rect.y[0] + offset[1]}px`,
      width: `${rect.x[1] - rect.x[0]}px`,
      height: `${rect.y[1] - rect.y[0]}px`,
    };
  }
}
